// Locations browser view
//
// Displays the list of the head office's locations.
// Provides functionality to browse and find locations by region, search and
// closest to user. Displays information about locations (address, opening
// hours, map, wait times etc.). Choose a location for the order
import jQuery from 'jquery';
import _ from 'lodash';
import i18n from 'i18next';

const { Order } = Mobi2Go;
const { Locations } = Mobi2Go;
const { UI } = Mobi2Go;

Mobi2Go.UI.View({
    name: 'locations_browser',
    model: 'Locations',
    el: '[data-view="locations-browser"]',
    templates: {
        // Location list display
        location_list: jQuery('[data-template="locations-list"]').html(),
        // Nearest locations list display
        nearest_location_list: jQuery(
            '[data-template="nearest-locations-list"]'
        ).html(),
        // Location info display
        location_info: jQuery('[data-template="location-info"]').html(),
    },
    initialise() {
        this.modal = new Mobi2Go.UI.Modal(this.$el);
        this.$list = this.jQuery('[data-locations]'); // List element
        this.$nearest = this.jQuery('[data-nearest-locations]');
        this.$info = this.jQuery('[data-location-info]'); // Info element
        Mobi2Go.UI.helpers.spinner(this.$list, true);
        // Wait for Locations module to finish loading before rendering html
        Locations.onReady(this.renderLocationList);

        // Listen for event to show locations modal
        Mobi2Go.UI.bind('showLocations', this.show);

        Order.bind('updateIsTest', this.renderLocationList);

        this.$el.localize();

        // Listen for the location services event so to render the nearest
        // locations
        // Mobi2Go.bind('app', 'setPosition', this.renderNearestLocationList);
        // Need to set up something whereby location services only runs if
        // there are greater than 20 stores.
    },
    selectLocation(id) {
        const that = this;

        // Set active item in locations list
        jQuery('.m2g-nav-list-item[data-location]')
            .removeClass('m2g-nav-list-item--active')
            .filter(`[data-location="${id}"]`)
            .addClass('m2g-nav-list-item--active');

        this.current_location = Locations.getById(id);

        if (!this.current_location.hasLoadedRecently()) {
            // Show spinner while location data loads
            Mobi2Go.UI.helpers.spinner(this.$info, true);
        }

        if (
            !Order.isTest() &&
            (this.current_location.isInactive() ||
                this.current_location.isLockedOut() ||
                this.current_location.isHidden())
        ) {
            this.jQuery('[data-set]')
                .removeClass('m2g-button--primary')
                .addClass('m2g-button--disabled');
        } else {
            this.jQuery('[data-set]')
                .addClass('m2g-button--primary')
                .removeClass('m2g-button--disabled');
        }

        // Load additional location data from the server
        this.current_location.load(function() {
            const html = that.templates.location_info(that.current_location);
            that.$info.html(html);
            that.$info.attr('data-location', that.current_location.id);
            that.$info.attr('data-location-name', that.current_location.name);
        });
    },

    // Loads the html list of locations
    renderLocationList() {
        const include_hidden_and_inactive = Order.isTest();
        const data = {
            // Object of locations grouped by region
            regions: Locations.getByRegion({ include_hidden_and_inactive }),
        };
        const html = this.templates.location_list(data);
        this.$list.html(html);

        if (Locations.hasOnlyOne()) {
            this.setDisplaySingleLocation();
        }
    },
    renderNearestLocationList() {
        const data = {
            nearest_locations: Locations.getSortedByDistance().slice(0, 5),
        };
        const html = this.templates.nearest_location_list(data);
        this.$nearest.html(html);
    },

    setDisplaySingleLocation() {
        this.jQuery('[data-nav]').hide();
        this.jQuery('[data-location-info]').addClass(
            'm2g-location-info--single-store'
        );
        this.jQuery('[data-title]').text('Store info');
        this.jQuery('[data-set]').text('Close');
    },

    // Show and hide modal
    show(location_obj) {
        this.modal.open();
        if (location_obj) {
            this.selectLocation(location_obj.id);
            this.focusLocationById(location_obj.id);
        } else if (!this.current_location) {
            // Load the fist location in the list if no location is set
            const location = Locations.getFirstNotHidden();
            this.selectLocation(location.id);
            this.focusLocationById(location.id);
        }
    },
    hide() {
        this.modal.close();
    },
    focusLocationById(id) {
        jQuery(`[data-location="${id}"]`).focus();
    },

    // When user clicks on a location in the list - load its info
    DOM_listeners: {
        'click .m2g-nav-list-item[data-location]': function(e) {
            const id = jQuery(e.currentTarget).data('location');
            this.selectLocation(id);
        },
        'keydown .m2g-nav-list-item[data-location]': function(e) {
            if (e.keyCode !== 13) {
                return;
            }

            const id = jQuery(e.currentTarget).data('location');

            if (id !== this.current_location.id) {
                this.selectLocation(id);
            } else {
                this.jQuery('[data-set]').focus();
            }
        },

        'click [data-set]': 'chooseLocationButtonClickHandler',
    },

    chooseLocationButtonClickHandler() {
        if (!this.current_location) {
            return;
        }

        if (!Order.isTest() && !this.current_location.isActive()) {
            return;
        }

        const that = this;
        UI.warnings.warnForUnavailableAndRestrictedProducts(
            this.current_location,
            function(accepted) {
                if (accepted) {
                    that.setCurrentLocationAndClose();
                }
            }
        );
    },
    setCurrentLocationAndClose() {
        const that = this;
        Order.setLocationById(this.current_location.id, true);
        this.modal.close();

        _.defer(function() {
            if (!UI.Modal.isOpen()) {
                UI.helpers.scrollTo(
                    '[data-view="order-location"]',
                    function() {
                        setTimeout(function() {
                            UI.alert({
                                title: i18n.t('order.location:store_set'),
                                body: `${i18n.t('order.location:ordering_from')}  ${that.current_location.name}`,
                                el: jQuery(
                                    '[data-view="order-location"] [data-order-location]'
                                ).parent(),
                                placement: 'left',
                                primary_button: null,
                                temp: true,
                                highlight_element: true,
                            });
                        }, 250);
                    },
                    true,
                    -150
                );
            }
        });
    },
});
